var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import Mascara from './mascara';
import { is_touch_device } from '../../util';

var toXPorciento = function toXPorciento(val, rect) {
  return 100 * (val - rect.left) / rect.width;
};

var toYPorciento = function toYPorciento(val, rect) {
  return 100 * (val - rect.top) / rect.height;
};

var Mascaras = function (_Component) {
  _inherits(Mascaras, _Component);

  function Mascaras(props) {
    _classCallCheck(this, Mascaras);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleMouseDown = function (e) {
      if (e.target !== _this.root) {
        return;
      }

      e.preventDefault();

      var rect = _this.root.getBoundingClientRect();

      var _ref = e.touches ? e.touches[0] : e,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      _this.setState({
        panel: {
          x: toXPorciento(clientX, rect),
          y: toYPorciento(clientY, rect),
          w: 0,
          h: 0
        }
      });
    };

    _this.handleMouseMove = function (e) {
      if (_this.state.panel === null) {
        return;
      }

      e.preventDefault();

      var rect = _this.root.getBoundingClientRect();

      var _ref2 = e.touches ? e.touches[0] : e,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      _this.setState(function (prevState) {
        return {
          panel: {
            x: prevState.panel.x,
            y: prevState.panel.y,
            w: toXPorciento(clientX, rect) - prevState.panel.x,
            h: toYPorciento(clientY, rect) - prevState.panel.y
          }
        };
      });
    };

    _this.handleMouseUp = function (e) {
      var panel = _this.state.panel;

      if (panel === null) {
        return;
      }

      e.preventDefault();
      var x = panel.x,
          y = panel.y,
          w = panel.w,
          h = panel.h;

      _this.setState({
        panel: null
      }, function () {
        return _this.props.onCrearPanel(x, y, w, h);
      });
    };

    _this.state = {
      // paneles: props.paneles,
      panel: null
    };
    return _this;
  } // componentDidUpdate(prevProps) {
  //     const { paneles } = this.props
  //     if (prevProps.paneles !== paneles) {
  //         this.setState({ paneles })
  //     }
  // }
  // handleEliminarPanel = id => {
  //     const { paneles } = this.state
  //     window.console.info(`Eliminando panel`, id)
  //     this.setState({
  //         paneles: paneles.filter( panel => panel.id !== id )
  //     })
  // }
  // handleCrearPanel = (x, y, w, h) => {
  //     const { paneles } = this.state
  //     const id = 'mascaras_panel_' + paneles.length
  //     window.console.info(`Creando panel`, id, x, y, w, h)
  //     this.setState({
  //         paneles: [
  //             ...paneles,
  //             {id, x, y, w, h }
  //         ]
  //     })
  // }
  // handleMoverPanel = (id, x, y, w, h) => { 
  //     const { paneles } = this.state
  //     this.setState({
  //         paneles: paneles.map(panel => {
  //             if (panel.id === id) {
  //                 return {id, x, y, w, h}
  //             }
  //             return panel
  //         })
  //     })
  //     window.console.info(`Panel ${id} modificado`, x, y, w, h) 
  // }


  Mascaras.prototype.renderPaneles = function renderPaneles() {
    var _props = this.props,
        paneles = _props.paneles,
        onMoverPanel = _props.onMoverPanel,
        onEliminarPanel = _props.onEliminarPanel;
    return paneles.map(function (panel) {
      return React.createElement(Mascara, _extends({
        key: 'mascaras_panel_' + panel.id
      }, panel, {
        onMoverPanel: onMoverPanel,
        onEliminarPanel: onEliminarPanel
      }));
    });
  };

  Mascaras.prototype.renderEditorPersianas = function renderEditorPersianas() {
    var _this2 = this; // const style = {
    // position: 'absolute',
    // left: 0, top: 0,
    // width: '100%', height: '100%',
    // backgroundColor: 'rgba(0, 0, 0, 0.1)',
    // cursor: 'crosshair',
    // zIndex: 1000
    // }


    var eventos = is_touch_device() ? {
      onTouchStart: this.handleMouseDown,
      onTouchMove: this.handleMouseMove,
      onTouchEnd: this.handleMouseUp
    } : {
      onMouseDown: this.handleMouseDown,
      onMouseMove: this.handleMouseMove,
      onMouseUp: this.handleMouseUp
    };
    return React.createElement('div', _extends({
      className: 'mascaras',
      ref: function ref(root) {
        return _this2.root = root;
      }
    }, eventos, {
      style: {
        pointerEvents: 'initial'
      }
    }), this.renderPaneles(), this.state.panel && React.createElement('div', {
      className: 'mascara crearMascara',
      style: {
        position: 'absolute',
        left: this.state.panel.x + '%',
        top: this.state.panel.y + '%',
        width: this.state.panel.w + '%',
        height: this.state.panel.h + '%'
      }
    }) // <Mascara {...this.state.panel} color='rgba(0,0,0,0.5)' />
    );
  };

  Mascaras.prototype.render = function render() {
    if (this.props.activas) {
      return this.renderEditorPersianas();
    }

    if (this.props.visibles) {
      return this.renderPaneles();
    }

    return false;
  };

  return Mascaras;
}(Component);

Mascaras.propTypes = process.env.NODE_ENV !== "production" ? {
  activas: t.bool.isRequired,
  visibles: t.bool.isRequired,
  paneles: t.array.isRequired,
  onMoverPanel: t.func.isRequired,
  onEliminarPanel: t.func.isRequired,
  onCrearPanel: t.func.isRequired
} : {};
export default Mascaras;